module.exports = __webpack_public_path__ + "static/media/final-05.48782ba3.svg";